import {
  getGrilledMaterials,
  createGrilledMaterial,
  updateGrilledMaterial,
  deleteGrilledMaterial,
  getGrilledFilterMaterials,
} from '../../api/grilledMaterials';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_GRILLED_MATERIALS_VALUE = 'CHANGE_GRILLED_MATERIALS_VALUE';
export const CHANGE_MODAL_GRILLED_MATERIALS_VALUE = 'CHANGE_MODAL_GRILLED_MATERIALS_VALUE';
export const CHANGE_GRILLED_MATERIALS_SEVERAL_VALUES = 'CHANGE_GRILLED_MATERIALS_SEVERAL_VALUES';

export const RESET_GRILLED_MATERIALS_STORE = 'RESET_GRILLED_MATERIALS_STORE';

export const GET_GRILLED_MATERIALS = 'GET_GRILLED_MATERIALS';
export const GET_GRILLED_MATERIALS_SUCCESS = 'GET_GRILLED_MATERIALS_SUCCESS';
export const GET_GRILLED_MATERIALS_ERROR = 'GET_GRILLED_MATERIALS_ERROR';

export const CREATE_GRILLED_MATERIAL = 'CREATE_GRILLED_MATERIAL';
export const CREATE_GRILLED_MATERIAL_SUCCESS = 'CREATE_GRILLED_MATERIAL_SUCCESS';
export const CREATE_GRILLED_MATERIAL_ERROR = 'CREATE_GRILLED_MATERIAL_ERROR';

export const UPDATE_GRILLED_MATERIAL = 'UPDATE_GRILLED_MATERIAL';
export const UPDATE_GRILLED_MATERIAL_SUCCESS = 'UPDATE_GRILLED_MATERIAL_SUCCESS';
export const UPDATE_GRILLED_MATERIAL_ERROR = 'UPDATE_GRILLED_MATERIAL_ERROR';

export const DELETE_GRILLED_MATERIAL = 'DELETE_GRILLED_MATERIAL';
export const DELETE_GRILLED_MATERIAL_SUCCESS = 'DELETE_GRILLED_MATERIAL_SUCCESS';
export const DELETE_GRILLED_MATERIAL_ERROR = 'DELETE_GRILLED_MATERIAL_ERROR';

export const getGrilledMaterialsAction = (function () {
  let prevController;

  return (params, setData) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_GRILLED_MATERIALS });
      try {
        const response = await getGrilledMaterials(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          setData([...results.content]);
          dispatch({ type: GET_GRILLED_MATERIALS_SUCCESS, payload: results });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          setData([]);
          dispatch({ type: GET_GRILLED_MATERIALS_ERROR });
        }
      }
    };
  };
})();

export const getGrilledFilterMaterialsAction = (actions = {}) => {
  return async () => {
    try {
      const response = await getGrilledFilterMaterials();
      const { success, results } = response;
      if (success) {
        actions.onSuccess && actions.onSuccess(results);
      }
    } catch (error) {
      console.log(error);
      actions.onError && actions.onError(error.message);
    }
  };
};

export const createGrilledMaterialAction = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_GRILLED_MATERIAL });
    try {
      const response = await createGrilledMaterial(params);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: CREATE_GRILLED_MATERIAL_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: CREATE_GRILLED_MATERIAL_ERROR });
    }
  };
};

export const updateGrilledMaterialAction = (uuid, params, actions) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_GRILLED_MATERIAL });
    try {
      const response = await updateGrilledMaterial(uuid, params);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: UPDATE_GRILLED_MATERIAL_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: UPDATE_GRILLED_MATERIAL_ERROR });
    }
  };
};

export const deleteGrilledMaterialAction = (uuid, actions) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_GRILLED_MATERIAL });
    try {
      const response = await deleteGrilledMaterial(uuid);
      const { success } = response;
      if (success) {
        actions.onSuccess();
        dispatch({ type: DELETE_GRILLED_MATERIAL_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions.onError(error.message);
      dispatch({ type: DELETE_GRILLED_MATERIAL_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_GRILLED_MATERIALS_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_GRILLED_MATERIALS_SEVERAL_VALUES,
  payload: value,
});

export const changeModalValue = (key, value) => ({
  type: CHANGE_MODAL_GRILLED_MATERIALS_VALUE,
  payload: {
    key,
    value,
  },
});

export const resetStore = () => ({
  type: RESET_GRILLED_MATERIALS_STORE,
});
